export function hexToRgba(hex, alpha = 0.6) {
  //return `rgba(${6}, ${0}, ${0}, ${1})`;
  
  if(hex==null) return  `rgba(255, 0, 0, ${alpha})`;
  
  //console.log("hex",hex);
  let r = 0, g = 0, b = 0;
  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else if (hex.length === 7) {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}